import { Label } from "@/components/ui/label";
import { Package } from "lucide-react";
import { motion } from "framer-motion";

interface PackageSelectionProps {
  selectedPackage: string;
  setSelectedPackage: (value: string) => void;
  packages: any[];
  unlimitedPhotos: boolean;
  setUnlimitedPhotos: (value: boolean) => void;
  getUnlimitedPhotoCost: (packageId: string) => number;
}

export const PackageSelection = ({
  selectedPackage,
  setSelectedPackage,
  packages,
  unlimitedPhotos,
  setUnlimitedPhotos,
  getUnlimitedPhotoCost
}: PackageSelectionProps) => {
  return (
    <motion.div whileHover={{ scale: 1.02 }} className="transition-all duration-300">
      <Label htmlFor="package" className="flex items-center gap-2">
        <Package className="w-4 h-4" />
        Select Package
      </Label>
      <select
        id="package"
        value={selectedPackage}
        onChange={(e) => {
          setSelectedPackage(e.target.value);
        }}
        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-navy-500 focus:border-navy-500 transition-all duration-300"
        required
      >
        <option value="">Choose a package...</option>
        {packages.map((pkg) => (
          <option key={pkg.id} value={pkg.id}>
            {pkg.name} - ${pkg.price} (Base: {pkg.baseResolution})
          </option>
        ))}
      </select>

      {selectedPackage && selectedPackage !== "ultra" && packages.find(p => p.id === selectedPackage)?.photoUpgrade && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-navy-50 p-4 rounded-lg mt-4"
        >
          <p className="text-navy-800">
            Add photo upgrade for +${getUnlimitedPhotoCost(selectedPackage)} (Max {packages.find(p => p.id === selectedPackage)?.photoUpgrade?.maxPhotos || 0} photos)
          </p>
          <div className="flex items-center gap-2 mt-2">
            <input
              type="checkbox"
              id="unlimited"
              checked={unlimitedPhotos}
              onChange={(e) => setUnlimitedPhotos(e.target.checked)}
              className="w-4 h-4 text-navy-600 border-gray-300 rounded focus:ring-navy-500"
            />
            <Label htmlFor="unlimited" className="text-navy-800">
              Add photo upgrade
            </Label>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};